export enum CameraCapability {
    LPR = 'LPR',
    AHCR = 'AHCR',
    G3 = 'G3'
}